import React from 'react';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="pt-16 bg-gradient-to-br from-blue-900 via-blue-800 to-cyan-600 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 animate-fade-in-up">
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight">
              Enterprise IT Solutions for
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-teal-400">
                {' '}Digital Transformation
              </span>
            </h1>
            <p className="text-xl text-blue-100 leading-relaxed">
              Accelerate your digital journey with cutting-edge consultation, agile development, 
              cloud-native deployment, and proactive maintenance solutions. We architect scalable 
              systems that drive innovation and operational excellence.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => scrollToSection('contact')}
                className="bg-white text-blue-900 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors text-center"
              >
                Schedule Consultation
              </button>
              <button
                onClick={() => scrollToSection('services')}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors text-center"
              >
                Explore Services
              </button>
            </div>
          </div>
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
              <div className="grid grid-cols-2 gap-4 text-center">
                <div className="bg-white/10 rounded-lg p-4">
                  <i className="fas fa-cloud text-3xl text-cyan-400 mb-2"></i>
                  <h3 className="font-semibold">Cloud Native</h3>
                  <p className="text-sm text-blue-200">Scalable Architecture</p>
                </div>
                <div className="bg-white/10 rounded-lg p-4">
                  <i className="fas fa-shield-alt text-3xl text-teal-400 mb-2"></i>
                  <h3 className="font-semibold">Security First</h3>
                  <p className="text-sm text-blue-200">Zero Trust Model</p>
                </div>
                <div className="bg-white/10 rounded-lg p-4">
                  <i className="fas fa-cogs text-3xl text-cyan-400 mb-2"></i>
                  <h3 className="font-semibold">DevOps</h3>
                  <p className="text-sm text-blue-200">CI/CD Pipeline</p>
                </div>
                <div className="bg-white/10 rounded-lg p-4">
                  <i className="fas fa-chart-line text-3xl text-teal-400 mb-2"></i>
                  <h3 className="font-semibold">Analytics</h3>
                  <p className="text-sm text-blue-200">Data-Driven Insights</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
